import { Injector } from '@angular/core';
import { NavigationExtras } from '@angular/router';

export type Application = AppModule | LinkModule;

export interface Module {
  type?: 'module' | 'link';
  name: string;
  description?: string;
  icon?: string;
  id?: number;
  image?: string;
  permission?: string;
  color?: string;
  group?: ModuleGroup;
  disabled?: boolean;
}
export interface ModuleGroup {
  id: number;
  name: string;
  icon?: string;
}
export const MODULE_GROUPS = Object.freeze([
  { id: 1, name: 'Stammdaten', icon: 'fa-database fa-regular' },
  { id: 2, name: 'Finanzbuchhaltung', icon: 'fa-regular fa-calculator' },
  { id: 3, name: 'Gewerbe', icon: 'fa-regular fa-building' },
  { id: 4, name: 'Handel', icon: 'fa-regular fa-shop' },
  { id: 5, name: 'Lager', icon: 'fa-regular fa-warehouse' },
  {
    id: 6,
    name: 'Mobile Datenerfassung (MDE)',
    icon: 'fa-regular fa-scanner-touchscreen',
  },
  { id: 7, name: 'Milchgeld', icon: 'fa-regular fa-milk' },
  { id: 8, name: 'Personalmanagement', icon: 'fa-people-roof fa-regular' },
  { id: 9, name: 'Produktion', icon: 'fa-regular fa-conveyor-belt-arm' },
  { id: 10, name: 'Schmuck', icon: 'fa-regular fa-gem' },
  { id: 11, name: 'Werkstatt', icon: 'fa-regular fa-garage-car' },
  { id: 12, name: 'Warenwirtschaft', icon: 'fa-regular fa-boxes-packing' },
  { id: 13, name: 'Elektronische Etiketten', icon: 'fa-barcode-read fa-regular' },
  { id: 14, name: 'Statistik', icon: 'fa-chart-simple fa-regular' },
  { id: 15, name: 'Kassa', icon: 'fa-cash-register fa-regular' },
  { id: 16, name: 'Fleischerei', icon: 'fa-steak fa-regular' },
  { id: 17, name: 'Kino', icon: 'fa-camera-movie fa-regular' },
  { id: 18, name: 'Technik', icon: 'fa-computer-classic fa-regular' },
  { id: 19, name: 'Workflow', icon: 'fa-arrow-progress fa-regular' },
] as const);

export type ModuleGroupId = (typeof MODULE_GROUPS)[number]['id'];
export const getModuleGroupById = (id: ModuleGroupId) =>
  (MODULE_GROUPS as readonly ModuleGroup[]).find((g) => g.id === id);
export const getModuleGroupByName = (name: string) =>
  (MODULE_GROUPS as readonly ModuleGroup[]).find((g) => g.name === name);

export interface LinkModule extends Module {
  type: 'link';
  href?: string;
  execute?: (_: Injector) => Promise<void>;
}

export interface AppModule extends Module {
  type?: 'module' | undefined;
  route: string;
  routeParams?: NavigationExtras;
}
